import $ from 'jquery';
import Cache from 'root/cache';
import View from 'view/base';
import {loadFeedbackCommentTemplates} from 'service/feedback';
import Modals from 'root/modals';
import Constants from 'root/constants';
import Util from 'root/module/util';

var Comment_Template = View.extend({
    className: 'comment-template-box borderless',

    search_value: '',
    hovered_template_id: null,

    events: {
        'mouseenter .feedback-comment-template-item': 'onMouseEnter',
        'click .feedback-comment-template-item': 'onSelect',
        'click .feedback-comment-template-edit': 'onEdit',
        'input input[name="search"]': 'onSearch'
    },

    dom_handlers: {
        onMouseEnter: function(e) {
            var target = $(e.currentTarget);
            var id = target.data('id');

            var model = Cache.feedback_comment_template.get(id);
            if (model && this.hovered_template_id !== id) {
                this.hovered_template_id = id;
                this.renderContent();
                this.renderTemplateList();
            }
        },

        onSelect: function(e) {
            var target = $(e.currentTarget);
            var id = target.data('id');

            var model = Cache.feedback_comment_template.get(id);
            if (model) {
                this.trigger('comment::insert', model.get('content'));
            }
        },

        onEdit: function(e) {
            Modals.openFeedbackCommentTemplate();
        },

        onSearch: function(e) {
            var search_value = $(e.currentTarget).val().trim().toLowerCase();
            this.search_value = search_value;

            var filtered_template = [];
            // handle the search part
            filtered_template = Cache.feedback_comment_template.filter((model) => {
                return model.get('name').toLowerCase().indexOf(this.search_value) !== -1;
            });

            if (filtered_template.length > 0) {
                this.hovered_template_id = filtered_template[0].id;
            } else {
                this.hovered_template_id = null;
            }

            this.renderTemplateList();
            this.renderContent();
        }
    },

    event_handlers: {
        onTemplateReset: function() {
            if (Cache.feedback_comment_template.length) {
                this.hovered_template_id = Cache.feedback_comment_template.at(0).id;
            } else {
                this.hovered_template_id = null;
            }

            this.render();
        }
    },

    initialize: function(options) {
        this.editable = options?.editable || false;
        this.listenTo(Cache.feedback_comment_template, 'reset', this.event_handlers.onTemplateReset);
        this.listenTo(Cache.feedback_comment_template, 'add', this.render);
        this.listenTo(Cache.feedback_comment_template, 'remove', this.render);
        this.listenTo(Cache.feedback_comment_template, 'change', this.render);
    },

    renderTemplateList: function() {
        var template = '';

        var filtered_template = [];
        // handle the search part
        filtered_template = Cache.feedback_comment_template.filter((model) => {
            return model.get('name').toLowerCase().indexOf(this.search_value) !== -1;
        });

        if (filtered_template.length === 0) {
            // show no template message
            template = '<div class="empty-state flex-start italic">No templates found</div>';
        } else {
            filtered_template.forEach((model) => {
                var access_type_raw = model.get('access_type').split(',');
                var access_type = access_type_raw.map(item => parseInt(item, 10));
                // check if this access type include 1
                var is_my_template = access_type.includes(Constants.FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_MYSELF);
                var is_hovered = this.hovered_template_id === model.id;

                template += '<div class="feedback-comment-template-item ' + (is_hovered ? 'hovered' : '') + ' flex-between" data-id="' + model.id + '">' +
                    '<div class="template-name">' + model.escape('name') + '</div>' +
                    (is_my_template ? '<i class="fas fa-lock tooltip" data-title="Myself only"></i>' : '') +
                '</div>';
            });
        }

        this.$el.find('.feedback-comment-template-list').html(template);
    },

    renderContent: function() {
        var template = '';

        if (this.hovered_template_id) {
            var model = Cache.feedback_comment_template.get(this.hovered_template_id);
            if (model) {
                template = model.escape('content');

                // replace blank lines with <br>
                template = template.replace(/\n/g, '<br>');
            }
        } else {
            template = '';
        }

        this.$el.find('.feedback-comment-template-content').html(template);
    },

    reset: function() {
        this.search_value = '';
        const templates = Cache.feedback_comment_template;

        if (templates.length > 0) {
            this.hovered_template_id = templates.first().id;
        } else {
            this.hovered_template_id = null;
        }
        this.render();
    },

    render: function() {
        var content = Cache.feedback_comment_template.isLoaded() ?
        '<div class="feedback-comment-template-container">' +
            '<div class="feedback-comment-selector">' +
                '<div class="search-box-container dropdown-search">' +
                    '<input type="text" class="solid compact" placeholder="Search templates..." name="search" value="' + Util.htmlEntities(this.search_value) + '">' +
                '</div>' +
                '<div class="feedback-comment-template-list">' +
                '</div>' +
            '</div>' +
            '<div class="feedback-comment-template-preview">' +
                '<div class="feedback-comment-template-preview-header">' +
                    '<span>Preview:</span>' +
                    (this.editable ?
                    '<button class="feedback-comment-template-edit text-info small round tooltip" type="button" data-title="Edit templates"><i class="fa-regular fa-solid fa-fw fa-cog"></i></button>' : '') +
                '</div>' +
                '<div class="feedback-comment-template-content"></div>' +
            '</div>' +
        '</div>' :
        (
            '<div class="loader-placeholder margin-bottom-8"></div>' +
            '<div class="loader-placeholder margin-bottom-8"></div>' +
            '<div class="loader-placeholder"></div>'
        );

        this.$el.html(content);

        // load the data from the server if the cache.feedback_comment_template is empty
        if (!Cache.feedback_comment_template.isLoaded()) {
            loadFeedbackCommentTemplates();
        }

        this.renderContent();
        this.renderTemplateList();

        return this;
    }
});

export default Comment_Template;
